import { defineComponent as d, ref as f } from "vue";
import { AutocompleteDropdown as r } from "@sunrise/types";
import { NOT_SET as t, track as s } from "@sunrise/tracking";
import { urlUtils as g } from "@sunrise/shared";
import h from "./index33.js";
import T from "./index37.js";
const w = d({
  name: "RelocationForm",
  components: {
    CsLocationAutocomplete: h,
    CsPrimaryButton: T
  },
  props: {
    buttonText: String,
    searchPhrase: String,
    url: {
      type: String,
      required: !0
    },
    locationLevels: Array
  },
  setup(i) {
    const l = f(null);
    let n = null;
    function m(e) {
      n = e;
    }
    async function c(e) {
      n = e.location, e.type !== r.SuggestionEmitValueTypes.TAB && a(e.type);
    }
    async function a(e) {
      if (!n)
        return;
      const o = {
        mslayer_element_data_id: "ed0000084",
        mslayer_element_text: t,
        mslayer_element_type_text: "RelocationBox",
        mslayer_element_count: t,
        mslayer_element_body_type: "text_body",
        mslayer_element_position: t,
        mslayer_element_id: t,
        mslayer_affiliate_id: t,
        mslayer_element_company_name: "default",
        mslayer_element_detail_start_date: t,
        mslayer_channel_search_channel_combo: t
      }, u = {
        ...o,
        mslayer_element_variant: _(e),
        mslayer_element_text: "Stadt suchen"
      }, y = {
        ...o,
        mslayer_element_variant: "autocomplete_submit",
        mslayer_channel_search_searchphrases: n.name || t
      };
      await Promise.all([s(u), s(y)]);
      const p = i.url.replace("{0}", n.id);
      g.redirect(p, {
        action: "relocation",
        words: n.id
      });
    }
    function _(e) {
      switch (e) {
        case r.SuggestionEmitValueTypes.CLICK:
          return "suggestion_submit";
        case r.SuggestionEmitValueTypes.ENTER:
          return "keypress_submit";
        default:
          return "button_submit";
      }
    }
    return {
      onSelect: c,
      redirect: a,
      formRef: l,
      onHighlighted: m
    };
  }
});
export {
  w as default
};
